import { PocketRow } from "@/components/ui";
import { useT } from "@/i18n";
import { settingsVoiceVocabularyMessages } from "@/i18n/messages/settings-voice-vocabulary";
import { isTauri } from "@/lib/is-tauri";
import { useDictationVocabularyStore } from "@/stores/dictation-vocabulary-store";
import { useSettingsNav } from "./settings-navigation";
import { vocabularySummary } from "./voice-vocabulary-summary";

/** Preferences › Voice: the words Denker should always get right, for all
 *  voice input (desktop). Opens the Vocabulary page. */
export function VoiceVocabularyRow() {
  const nav = useSettingsNav();
  const t = useT(settingsVoiceVocabularyMessages);
  const words = useDictationVocabularyStore((state) => state.words);
  if (!isTauri()) return null;
  return (
    <PocketRow
      testId="settings-row-voice-vocabulary"
      title={t("vocabulary")}
      secondLine={vocabularySummary(words)}
      chevron
      onSelect={() => nav.push({ page: "preferences-voice-vocabulary" })}
    />
  );
}
